import React, { useRef } from "react";
import { toast } from "react-toastify";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image";
import { saveAs } from "file-saver";

export default function QRCodeModal({ show, onClose, checkpoint }) {
  const qrCodeRef = useRef(null);

  if (!show || !checkpoint) return null;

  const printQRCode = () => {
    if (qrCodeRef.current) {
      const printWindow = window.open("", "_blank");
      const qrCodeHTML = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>QR Code - ${checkpoint.name}</title>
            <style>
              body {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100vh;
                margin: 0;
                font-family: Arial, sans-serif;
              }
              .qr-container {
                text-align: center;
                padding: 20px;
              }
              .qr-title {
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 10px;
              }
              .qr-code {
                margin: 20px 0;
              }
              .qr-code-text {
                font-size: 16px;
                margin-top: 10px;
                word-break: break-all;
              }
            </style>
          </head>
          <body>
            <div class="qr-container">
              <div class="qr-title">${checkpoint.name}</div>
              <div class="qr-code">
                ${qrCodeRef.current.innerHTML}
              </div>
              <div class="qr-code-text">${checkpoint.code}</div>
            </div>
          </body>
        </html>
      `;
      printWindow.document.write(qrCodeHTML);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 250);
    }
  };

  const downloadQRCode = async () => {
    if (qrCodeRef.current) {
      try {
        const dataUrl = await toPng(qrCodeRef.current, {
          quality: 1.0,
          pixelRatio: 2,
          backgroundColor: "#ffffff",
        });
        const filename = `QR-${checkpoint.name}-${checkpoint.code}.png`;
        saveAs(dataUrl, filename);
        toast.success("QR code downloaded successfully");
      } catch (error) {
        console.error("Error downloading QR code:", error);
        toast.error("Failed to download QR code");
      }
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-700">QR Code</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
        <div className="text-center mb-4">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">
            {checkpoint.name}
          </h3>
          <p className="text-sm text-gray-600 mb-4 font-mono">{checkpoint.code}</p>
          <div
            ref={qrCodeRef}
            className="bg-white p-4 border-2 border-gray-300 rounded-lg inline-block"
            style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
          >
            <QRCode
              value={checkpoint.code}
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              viewBox="0 0 256 256"
            />
            <p className="text-xs text-gray-500 mt-2 text-center max-w-xs break-all">
              {checkpoint.code}
            </p>
          </div>
          {checkpoint.locationID && (
            <p className="text-sm text-gray-500 mt-2">
              Location: {checkpoint.locationID.name || "-"}
            </p>
          )}
        </div>
        <div className="flex gap-3 justify-end">
          <button
            onClick={downloadQRCode}
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
          >
            <i className="fa fa-download mr-2"></i>
            Download
          </button>
          <button
            onClick={printQRCode}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
          >
            <i className="fa fa-print mr-2"></i>
            Print
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

